/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { C as Chip, d as defineCustomElement$1 } from './chip.js';

const CalciteChip = Chip;
const defineCustomElement = defineCustomElement$1;

export { CalciteChip, defineCustomElement };

//# sourceMappingURL=calcite-chip.js.map